import $ from "jquery";

$(function () {
  function dataLayer() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "contact_form_submission",
      url: window.location.href,
      formType: "Contact",
    });
  }

  $("body").on("submit", ".js-contact-form", function (e) {
    e.preventDefault();

    // Store a reference to the form
    var form = $(this);

    // Grab recaptcha key from localize script
    const recaptchaKey = form.attr("data-key");

    // Get recaptcha token then submit form
    grecaptcha
      .execute(recaptchaKey, { action: "contact_form" })
      .then(function (token) {
        $(form).find(".js-recaptcha-input").val(token);
        submitContactForm(form);
      });

    let valid = true;

    if (
      $(".js-contact-form")
        .find(".form-required")
        .each(function () {
          if ($(this).val() === "") {
            $(this).next().removeClass("hidden");
            valid = false;
          } else {
            $(this).next().addClass("hidden");
          }
        })
    ) {
    }

    const submitContactForm = (form) => {
      const data = new FormData(form[0]);

      if (valid === true) {
        $.ajax({
          url: "/wp-json/pb/v1/form",
          method: "POST",
          data: data,
          processData: false,
          contentType: false,
          success: function (data) {
            if (data.success) {
              window.location.href = data.redirect;
            }
            dataLayer();
          },
          error: function (err) {
            console.log(err);
          },
        });
      }
    };
  });
});
